"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _FileUploader = _interopRequireDefault(require("./FileUploader")),
    _utils = require("../utils");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var AssetUploader = function AssetUploader(apiClient) {
  (0, _classCallCheck2["default"])(this, AssetUploader), _initialiseProps.call(this), this._apiClient = apiClient, this._queue = (0, _utils.Queue)(), this._originalFile = this.getFileWrapper(), this._fileUploader = this.getFileUploader({
    addUploadTasksToQueue: this._queue.addUploadTasks,
    apiClient: this._apiClient
  }), this._handlers = this.getHandlers({
    originalFile: this._originalFile,
    apiClient: this._apiClient
  });
},
    _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.getFileWrapper = function () {
    return {
      isComplete: !1,
      uploader: void 0,
      setCompleted: function setCompleted() {
        this.isComplete = !0;
      }
    };
  }, this.getFileUploader = function (_ref) {
    var addUploadTasksToQueue = _ref.addUploadTasksToQueue,
        apiClient = _ref.apiClient;
    return function (params) {
      return (0, _FileUploader["default"])(_objectSpread({
        addUploadTasksToQueue: addUploadTasksToQueue,
        apiClient: apiClient
      }, params));
    };
  }, this.getHandlers = function (_ref2) {
    var originalFile = _ref2.originalFile,
        apiClient = _ref2.apiClient;
    return function (_ref3) {
      var handleAssetUpdates = _ref3.handleAssetUpdates,
          totalSize = _ref3.totalSize,
          asset = _ref3.asset;
      return (0, _utils.createAssetUploaderHandlers)({
        handleAssetUpdates: handleAssetUpdates,
        asset: asset,
        totalSize: totalSize,
        originalFile: originalFile,
        apiClient: apiClient
      });
    };
  }, this.createAsset = function () {
    var _ref5 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(_ref4) {
      var organisationId, file, metaData;
      return _regenerator["default"].wrap(function (_context) {
        for (;;) {
          switch (_context.prev = _context.next) {
            case 0:
              return organisationId = _ref4.organisationId, file = _ref4.file, metaData = _ref4.metaData, _context.abrupt("return", (0, _utils.createAsset)(_this._apiClient, {
                organisationId: organisationId,
                title: file.name,
                filename: file.name,
                metaData: metaData
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function () {
      return _ref5.apply(this, arguments);
    };
  }(), this.uploadAsset = function () {
    var _ref7 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee2(_ref6) {
      var asset, handleAssetUpdates, file, handlers, assetId, organisationId, metaData, ORIGINAL;
      return _regenerator["default"].wrap(function (_context2) {
        for (;;) {
          switch (_context2.prev = _context2.next) {
            case 0:
              asset = _ref6.asset, handleAssetUpdates = _ref6.handleAssetUpdates, file = _ref6.file, handleAssetUpdates([_objectSpread({}, asset, {
                loaded: 0,
                loadedPercent: 0,
                totalSize: file.size
              })]), handlers = _this._handlers({
                handleAssetUpdates: handleAssetUpdates,
                asset: asset,
                totalSize: file.size
              }), assetId = asset.assetId, organisationId = asset.organisationId, metaData = asset.metaData, ORIGINAL = asset.assetFiles.ORIGINAL, _this._originalFile.uploader = _this._fileUploader(_objectSpread({
                bucketKey: "organisation/".concat(organisationId, "/asset/").concat(assetId, "/file"),
                file: file,
                ORIGINAL: ORIGINAL,
                assetId: assetId,
                organisationId: organisationId,
                metaData: metaData
              }, handlers)), _this._originalFile.uploader.start();

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function () {
      return _ref7.apply(this, arguments);
    };
  }(), this.retryAssetUpload = function () {
    var _ref9 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee3(_ref8) {
      var handleAssetUpdates, file, assetId, organisationId, localAsset, bucketKey, assetFiles, metaData, asset, handlers;
      return _regenerator["default"].wrap(function (_context3) {
        for (;;) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (handleAssetUpdates = _ref8.handleAssetUpdates, file = _ref8.file, assetId = _ref8.assetId, organisationId = _ref8.organisationId, localAsset = (0, _utils.getAssetFromLocalStorage)(assetId), localAsset && (0, _utils.isAssetInLocalStorage)(localAsset, file)) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return");

            case 4:
              bucketKey = localAsset.bucketKey, assetFiles = localAsset.assetFiles, metaData = localAsset.metaData, asset = {
                assetId: assetId,
                organisationId: organisationId,
                assetFiles: assetFiles,
                metaData: metaData
              }, handleAssetUpdates([_objectSpread({}, asset)]), handlers = _this._handlers({
                handleAssetUpdates: handleAssetUpdates,
                asset: asset,
                totalSize: file.size
              }), handlers.progress(localAsset.uploadedBytes), _this._originalFile.uploader = _this._fileUploader(_objectSpread({
                bucketKey: bucketKey,
                file: file,
                assetId: assetId,
                organisationId: organisationId,
                ORIGINAL: assetFiles.ORIGINAL,
                metaData: metaData,
                cacheUploadId: localAsset.uploadId,
                uploadedParts: localAsset.uploadedParts,
                uploadedBytes: localAsset.uploadedBytes
              }, handlers)), _this._originalFile.uploader.start();

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function () {
      return _ref9.apply(this, arguments);
    };
  }();
},
    _default = AssetUploader;

exports["default"] = _default;